import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';

import { Action, ActionType, User } from '@models';
import { ActionService } from '@services';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
  ],
  templateUrl: './actions.page.html',
  styleUrl: './actions.page.scss',
})
export class ActionsPage implements OnInit {
  columns: string[] = ['date', 'user', 'performedBy', 'action', 'document'];

  public loading: boolean = true;
  public pageSize: number = 20;
  public pageIndex: number = 0;
  public totalActions: number = 0;
  public actions: Action[] = [];

  constructor(private actionService: ActionService) {}

  public ngOnInit(): void {
    this.fetchActionsPage();
  }

  public getActionName(action: ActionType): string {
    if (action === ActionType.LOGIN) return 'Login';
    if (action === ActionType.APPROVE_DOCUMENT) return 'Approve Document';
    if (action === ActionType.DECLINE_DOCUMENT) return 'Decline Document';
    if (action === ActionType.ASSIGN_VEHICLE) return 'Assign Vehicle';
    if (action === ActionType.UNASSIGN_VEHICLE) return 'Unassign Vehicle';
    if (action === ActionType.APPROVE_ADDRESS) return 'Approve Address';
    if (action === ActionType.DECLINE_ADDRESS) return 'Decline Address';
    if (action === ActionType.APPROVE_PROFILE) return 'Approve Profile';
    if (action === ActionType.DECLINE_PROFILE) return 'Decline Profile';
    if (action === ActionType.CONTRACT_CREATED) return 'Contract Created';
    if (action === ActionType.CONTRACT_UPDATED) return 'Contract Updated';
    if (action === ActionType.CONTRACT_DELETED) return 'Contract Deleted';
    if (action === ActionType.APPROVE_BANKING_DETAILS)
      return 'Approve Banking Details';
    if (action === ActionType.DECLINE_BANKING_DETAILS)
      return 'Decline Banking Details';
    return '';
  }

  public onPageChange(e: PageEvent): void {
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.fetchActionsPage();
  }

  private async fetchActionsPage(): Promise<void> {
    this.loading = true;

    try {
      const response = await this.actionService.getPage({
        offset: this.pageIndex * this.pageSize,
        limit: this.pageSize,
      });
      this.totalActions = response.count;
      this.actions = response.data;
    } catch (err) {
      // TODO: handle error
    }

    this.loading = false;
  }

  public getUserDisplay(user: User): string {
    if (!user) return 'Unknown User';
    if (user.email) return user.email;
    return user.mobile;
  }
}
